import React from 'react'

import { Portlet, Form, Col, Row, Button } from '_zari/core'

import { Formik } from 'formik'

import * as FormGroups from './formGroups'

import { ZariContext } from '_zari/context'
import { AdminContext } from 'contexts/AdminContext'

import * as BackgroundJobsService from 'services/backgroundJobs.service'

const MainForm = () => {

  const __zariContext = React.useContext(ZariContext)
  const __adminContext = React.useContext(AdminContext)

  const formInitialValues = {
    mes: __adminContext.mesTrabajo || ''
  }

  const submitHandler = (formData, { setSubmitting }) => {
    if (!formData.mes) {
      __zariContext.snack('error', "Escoge un periodo, por favor.")
      setSubmitting(false)
      return
    }
    // El SIRE es asíncrono y puede tardar varios minutos → se procesa en segundo plano.
    // El usuario lo descarga desde la campana / "Procesos en segundo plano" cuando termine.
    BackgroundJobsService.iniciarJob('SIRE_COMPARACION', { periodo: formData.mes })
      .then(() => {
        __zariContext.toast(
          'success',
          'El reporte se está generando en segundo plano. Te avisaremos en la campana cuando esté listo para descargar.'
        )
      })
      .catch(({ data }) => {
        __zariContext.snack('error', (data && (data.error || data.message)) || 'No se pudo iniciar el proceso.')
      })
      .finally(() => {
        setSubmitting(false)
      })
  }

  return (
    <>
      <Portlet>
        <Portlet.Header title='Descargar Comparacion' />
        <Portlet.Body>
          <Row>
            <Col md={12}>
              <Formik initialValues={formInitialValues} onSubmit={submitHandler}>
                {({ errors, touched, isSubmitting, handleSubmit }) => (
                  <Form>
                    <Row>
                      <Col md={12}>
                        <FormGroups.MesContabilidadFormGroup />
                      </Col>
                    </Row>
                    <Row>
                      <Col md={12} className='text-right'>
                        <Button disabled={isSubmitting} onClick={handleSubmit}>
                          Generar Reporte
                        </Button>
                      </Col>
                    </Row>
                  </Form>
                )}
              </Formik>
            </Col>
          </Row>
        </Portlet.Body>
      </Portlet>
    </>
  )
}

export default React.memo(MainForm)
